import { render, staticRenderFns } from "./Egreso.vue?vue&type=template&id=cf55487a&scoped=true"
import script from "./Egreso.vue?vue&type=script&lang=js"
export * from "./Egreso.vue?vue&type=script&lang=js"
import style0 from "./Egreso.vue?vue&type=style&index=0&id=cf55487a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf55487a",
  null
  
)

export default component.exports